import { QueryClient } from "@tanstack/react-query";
import { logError } from "./logError";

const MAX_RETRIES = 3;
const HTTP_STATUSES_TO_NOT_RETRY = [400, 401, 403, 404, 405];

export const queryClient = new QueryClient({
  defaultOptions: {
    mutations: { onError: error => logError(error, { loggedFrom: "QueryClient" }) },
    queries: {
      staleTime: 10 * 1000 /** 10 seconds */,
      retry: (failureCount, error) => {
        if (failureCount > MAX_RETRIES) return false;

        if (!isErrorWithStatus(error)) return false;

        return !HTTP_STATUSES_TO_NOT_RETRY.includes(error.status);
      },
    },
  },
});

type ErrorWithStatus = { status: number };
export const isErrorWithStatus = (error: unknown): error is ErrorWithStatus =>
  typeof error === "object" && error !== null && "status" in error;
